import { createContext, useContext, useState, useCallback } from 'react';

const NotificationContext = createContext();
export const useNotification = () => useContext(NotificationContext);

export function NotificationProvider({ children }) {
  const [notification, setNotification] = useState(null);

  const showNotification = useCallback((info) => {
    // info = { type, title, message }
    setNotification(info);
  }, []);

  const hideNotification = useCallback(() => {
    setNotification(null);
  }, []);

  return (
    <NotificationContext.Provider
      value={{ showNotification, hideNotification }}
    >
      {children}

      {notification && (
        <div className={`notification-banner ${notification.type}`}>
          <button className="notification-close" onClick={hideNotification}>
            ✖
          </button>

          <div className="notification-content">
            <strong>{notification.title}</strong>

            {Array.isArray(notification.message) ? (
              notification.message.map((line, i) => (
                <div key={i} className="notification-line">
                  {line}
                </div>
              ))
            ) : (
              <div className="notification-line">{notification.message}</div>
            )}
          </div>

          {notification.extraButtons?.length > 0 && (
            <div className="notification-actions">
              {notification.extraButtons.map((btn, i) => (
                <button
                  key={i}
                  onClick={btn.action}
                  className="button-md button-gray"
                >
                  {btn.type === 'download' && (
                    <img
                      src={`${process.env.PUBLIC_URL}/icons/file-pdf.png`}
                      alt="pdf"
                      className="button-icon"
                    />
                  )}
                  {btn.label}
                </button>
              ))}
            </div>
          )}
        </div>
      )}
    </NotificationContext.Provider>
  );
}
